



























import { Component, Vue, Prop } from 'vue-property-decorator';
import GrowingNumber from '@/components/GrowingNumber.vue';

@Component({
  components: {
    GrowingNumber
  }
})
export default class TxtCardWidget extends Vue {
  
  @Prop({ default: '',  type: String}) icon!: string;
  @Prop({ default: '',  type: String}) text!: string;
  @Prop({ default: '',  type: String}) label!: string;
  @Prop({ default: '',  type: String}) type!: string;
  
}
